"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENABLE_LOGGING = exports.LOG_ALL = exports.TEST = exports.STAGE = exports.DEV = exports.ENVIRONMENT = void 0;
// All environment variables
var ENVIRONMENT = process.env;
exports.ENVIRONMENT = ENVIRONMENT;
var DEV = ENVIRONMENT.NODE_ENV === 'development';
exports.DEV = DEV;
var STAGE = ENVIRONMENT.NODE_ENV === 'stage';
exports.STAGE = STAGE;
var TEST = ENVIRONMENT.NODE_ENV === 'test';
exports.TEST = TEST;
var LOG_ALL = ENVIRONMENT.LOG_ALL;
exports.LOG_ALL = LOG_ALL;
var ENABLE_LOGGING = TEST || DEV || STAGE || LOG_ALL;
exports.ENABLE_LOGGING = ENABLE_LOGGING;